import React, {useState} from 'react';

import {images} from "../../constants";
import './Footer.scss'
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrap";
import {client} from "../../client";

function Footer() {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    })
    const [isFormSubmitted, setIsFormSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)
    const {name, email, message} = formData

    function handleChangeInput(e){
        const {name, value} = e.target
        setFormData({...formData, [name] : value})
    }

    function handleSubmit(){
        setLoading(true)

        const contact = {
            _type: 'contact',
            name: name,
            email: email,
            message: message
        }

        client.create(contact).then(() => {
            setIsFormSubmitted(true)
            setLoading(false)
        })
    }

    return (
        <>
            <h2 className="head-text">Contact <span>Me</span></h2>

            <div className="app__footer-cards">
                <div className="app__footer-card">
                    <img src={images.email} alt={"Email"}/>
                    <a href="mailto:oleksandr.dendeberia@gmail.com" className="p-text">oleksandr.dendeberia@gmail.com</a>
                </div>
            </div>

            {!isFormSubmitted ?
                <div className="app__footer-form app__flex">
                    <div className="app__flex">
                        <input name="name"
                               className="p-text"
                               type="text"
                               placeholder="Your name"
                               value={name}
                               onChange={handleChangeInput}/>
                    </div>
                    <div className="app__flex">
                        <input name="email"
                               className="p-text"
                               type="email"
                               placeholder="Your email"
                               value={email}
                               onChange={handleChangeInput}/>
                    </div>
                    <div>
                    <textarea
                        className="p-text"
                        placeholder="Your message"
                        value={message}
                        name={"message"}
                        onChange={handleChangeInput}
                    />
                    </div>
                    <button type={"button"} className="p-text"
                            onClick={handleSubmit}>{loading ? 'Sending..' : 'Send message'}</button>
                </div>
                : <div>
                    <h3 className="head-text">Thank you for getting in touch!</h3>
                </div>
            }
        </>
    );
}

export default AppWrap(MotionWrap(Footer, 'app__footer'), 'contact', 'app__whitebg');